import { CtrlType } from "@yuigoto/ctrl";
import React from "react";
import { NavLink } from "react-router-dom";

export const GlampartnerDataControl = [
    [
        {
            name: "issueInvoice",
            label: "emissaoNF",
            type: CtrlType.BOOLEAN,
            description: "Emite Nota Fiscal ?",
            custom: true,
             wrapClass: "col-12",
        },
    ],

    [
        {
            name: "pis",
            type: CtrlType.PIS,
            placeholder: "xxx.xxxxx.xx-x",
            label: "PIS",
            wrapClass: "col-12 col-sm-12 col-md-6",
            component: () => {
                return (
                    <p className={"form-info"}>
                        * Para podermos efetuar seus pagamentos precisamos dessa informação. Não sabe o que é o PIS?
                        <NavLink to={"/glampartner/pis"}> Clique aqui </NavLink>
                    </p>
                )
            },
            custom: true
        }
    ],
    [
        {
            name: "cnpjHolder",
            label: "CNPJ",
            placeholder: "CNPJ",
            required: false,
            requiredMessage: "Preencher o CNPJ é obrigatório",
            wrapClass: "col-12 col-sm-12 col-md-6",
            type: CtrlType.HIDDEN,
            description: "OBS: Preencha o CNPJ"
        }
    ],

    [
        {
            name: "companyName",
            alias: "companyName",
            required: false,
            requiredMessage: "Preencher o nome é obrigatório",
            placeholder: "Razão Social",
            regex: /^([^\d]*)$/,
            regexMessage: "Valor Inválido",
            label: "Razão Social",
            wrapClass: "col-12 col-sm-12 col-md-6",
            type: CtrlType.HIDDEN,
            description: "OBS: Preencha a razão social"
        },
        {
            name: "nickCompanyName",
            alias: "nickCompanyName",
            required: false,
            requiredMessage: "Preencher o nome é obrigatório",
            placeholder: "Nome Fantasia (artístico)",
            regex: /^([^\d]*)$/,
            regexMessage: "Valor Inválido",
            label: "Nome Fantasia (artístico)",
            wrapClass: "col-12 col-sm-12 col-md-6",
            type: CtrlType.HIDDEN,
            description: "OBS.: Preencha de acordo com o nome utilizado no portal ou redes sociais"
        },
    ],

    [
        {
            name: "accountHolder",
            alias: "accountHolder",
            required: true,
            requiredMessage: "Preencher o nome é obrigatório",
            placeholder: "Nome do favorecido",
            regex: /^([^\d]*)$/,
            regexMessage: "Valor Inválido",
            label: "Nome do favorecido",
            wrapClass: "col-12 col-sm-12 col-md-6",
            description: "OBS: Preencha todos os nomes"

        },
        {
            name: "accountHolderLastName",
            alias: "accountHolderLastName",
            required: true,
            requiredMessage: "Preencher o sobrenome é obrigatório",
            regex: /^([^\d]*)$/,
            regexMessage: "Valor Inválido",
            label: "Sobrenome do favorecido",
            wrapClass: "col-12 col-sm-12 col-md-6",
            description: "OBS: Preencha todos os sobrenomes"
        }
    ],
    [
        {
            name: "rgHolder",
            alias: "rgHolder",
            placeholder: "xx.xxx.xxx-x",
            label: "RG do favorecido",
            wrapClass: "col-12 col-sm-12 col-md-6",
            required: true,
            requiredMessage: "Este campo é obrigatório.",
            maxLength: '12',
            minLength: '8'
        },
        {
            name: "cpfHolder",
            alias: "cpf",
            type: CtrlType.CPF,
            placeholder: "xxx.xxx.xxx-xx",
            label: "CPF do favorecido",
            wrapClass: "col-12 col-sm-12 col-md-6",
            required: true,
            requiredMessage: "Este campo é obrigatório."
        },
    ],
    [
        {
            name: "pix",
            alias: "pix",
            label: "PIX do favorecido",
            wrapClass: "col-12 col-sm-12 col-md-6"

        },
        {
            name: "pixType",
            label: "Tipo de chave PIX",
            wrapClass: "col-12 col-sm-12 col-md-6",
            type: CtrlType.DROPDOWN,
            options: [
                {
                    "value": "",
                    "name": ""
                },
                {
                    "value": "Cpf",
                    "name": "Cpf"
                },
                {
                    "value": "Cnpj",
                    "name": "Cnpj"
                },
                {
                    "value": "Email",
                    "name": "Email"
                },
                {
                    "value": "Telefone",
                    "name": "Telefone"
                },
                {
                    "value": "ChaveAleatória",
                    "name": "Chave Aleatória"
                }

            ]
        }
    ],
    [
        {
            name: "bankCode",
            type: CtrlType.HIDDEN
        },
        {
            name: "bankName",
            alias: "bankName",
            label: "Banco",
            wrapClass: "col-12 sm-12 col-md-6",
            required: true,
            requiredMessage: "Este campo é obrigatório.",
            type: CtrlType.DATALIST,
            options: []
        },

        {
            name: "accountType",
            label: "Tipo de conta",
            wrapClass: "col-12 sm-12 col-md-6",
            required: true,
            requiredMessage: "Este campo é obrigatório.",
            type: CtrlType.DROPDOWN,
            options: [
                {
                    "value": "",
                    "name": ""
                },
                {
                    "value": "Corrente",
                    "name": "Corrente"
                },
                {
                    "value": "Poupança",
                    "name": "Poupança"
                },
            ]
        }
    ],
    [
        {
            name: "agency",
            label: "Agência",
            wrapClass: "col-6 col-sm-6 col-md-3",
            required: true,
            requiredMessage: "Este campo é obrigatório."
        },
        {
            name: "agencyDigit",
            alias: "agencyDigit",
            label: "Agência Dígito",
            wrapClass: "col-6 col-sm-6 col-md-3"
        },
        {
            name: "account",
            label: "Conta",
            wrapClass: "col-6 col-sm-6 col-md-3",
            required: true,
            requiredMessage: "Este campo é obrigatório."
        },
        {
            name: "accountDigit",
            alias: "accountDigit",
            label: "Conta Dígito",
            wrapClass: "col-6 col-sm-6 col-md-3"
        }
    ],
]
